import {ISyncField} from "../../../index";
import {nsObjectUpload} from "./fn";
import AssignMode = nsObjectUpload.AssignMode;

interface IMapping {
    heading: KnockoutObservable<string>
    syncfield: KnockoutObservable<ISyncField | undefined>
    mode: KnockoutObservable<AssignMode>
    input: KnockoutObservable<string | null>
}
